var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Checkbox } from "../../Checkbox";
import { Input } from "../../Input";
import { RadioButtons } from "../../RadioButtons";
import { Select } from "../../Select";
import { StaticInputValue, StaticMultipleValues } from "../../StaticInput";
import { Tooltip } from "../../Tooltip";
import { FormGridColumnTypes, } from "../../types/FormGrids";
import { CheckedState, SetRadioButton } from "./FormGridComponents";
import { v4 as uuidv4 } from "uuid";
export var FormGridInput = function (props) {
    var helperTooltip = props.helperTooltip;
    if (helperTooltip && (props === null || props === void 0 ? void 0 : props.column.type) === FormGridColumnTypes.Checkbox) {
        return (React.createElement(Tooltip, { tooltipId: uuidv4(), content: helperTooltip, iconShown: false },
            React.createElement(FormGridInputComponents, __assign({}, props))));
    }
    return React.createElement(FormGridInputComponents, __assign({}, props));
};
export var FormGridInputComponents = function (_a) {
    var _b, _c, _d;
    var column = _a.column, labelHidden = _a.labelHidden, viewState = _a.viewState, rowId = _a.rowId, disabled = _a.disabled, dataId = _a.dataId, dataTestId = _a.dataTestId;
    var name = column.id, required = column.required;
    var isValid = function (v) { return (required ? !!v : true); };
    switch (column.type) {
        case FormGridColumnTypes.Text:
            if (column.read || viewState === "read") {
                return (React.createElement(StaticInputValue, { name: name, label: column.label, labelHidden: true, staticFormatter: column.staticFormatter, dataId: dataId && "".concat(dataId, "-staticInput"), dataTestId: dataTestId && "".concat(dataTestId, "-staticInput") }));
            }
            else {
                return (React.createElement(Input, { label: column.label, type: "text", name: name, valid: isValid, onChange: function (value) {
                        return column.onChange && column.onChange(rowId, value);
                    }, uniqueId: "".concat(name, "-").concat(rowId), labelHidden: labelHidden, disabled: disabled, dataId: dataId && "".concat(dataId, "-input"), dataTestId: dataTestId && "".concat(dataTestId, "-input") }));
            }
        case FormGridColumnTypes.Radio:
            if (column.read || viewState === "read") {
                return column.staticFormatter ? (React.createElement(StaticMultipleValues, { name: name, label: column.label, labelHidden: true, staticFormatter: column.staticFormatter, options: column.options, dataId: dataId && "".concat(dataId, "-multiValue"), dataTestId: dataTestId && "".concat(dataTestId, "-multiValue") })) : (React.createElement(SetRadioButton, { name: name, options: column.options, dataId: dataId && "".concat(dataId, "-setRadioButton"), dataTestId: dataTestId && "".concat(dataTestId, "-setRadioButton") }));
            }
            else {
                return (React.createElement(RadioButtons, { name: name, label: !labelHidden ? column.label : undefined, options: (_b = column.options) !== null && _b !== void 0 ? _b : [], type: "button", onChange: function (option) {
                        return column.onChange && column.onChange(rowId, option);
                    }, valid: isValid, uniqueId: "".concat(name, "-").concat(rowId), disabled: disabled, dataId: dataId && "".concat(dataId, "-radioButton"), dataTestId: dataTestId && "".concat(dataTestId, "-radioButton") }));
            }
        case FormGridColumnTypes.Select:
            if (column.read || viewState === "read") {
                return (React.createElement(StaticMultipleValues, { name: name, label: column.label, labelHidden: true, staticFormatter: column.staticFormatter, options: (_c = column.options) !== null && _c !== void 0 ? _c : [], dataId: dataId && "".concat(dataId, "-multiValue"), dataTestId: dataTestId && "".concat(dataTestId, "-multiValue") }));
            }
            else {
                return (React.createElement(Select, { label: column.label, name: name, options: (_d = column.options) !== null && _d !== void 0 ? _d : [], labelHidden: labelHidden, onChange: function (option) {
                        return column.onChange && column.onChange(rowId, option);
                    }, valid: isValid, uniqueId: "".concat(name, "-").concat(rowId), disabled: disabled, dataId: dataId && "".concat(dataId, "-select"), dataTestId: dataTestId && "".concat(dataTestId, "-select") }));
            }
        case FormGridColumnTypes.Checkbox:
            if (column.read || viewState === "read") {
                return React.createElement(CheckedState, { name: name });
            }
            else {
                return (React.createElement(Checkbox, { name: name, description: column.label, descriptionHidden: labelHidden, onChange: function (value) {
                        return column.onChange && column.onChange(rowId, value);
                    }, valid: isValid, uniqueId: "".concat(name, "-").concat(rowId), disabled: disabled, dataId: dataId && "".concat(dataId, "-checkbox"), dataTestId: dataTestId && "".concat(dataTestId, "-checkbox") }));
            }
        default:
            return null;
    }
};
